import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { House, ListNumbers, GearSix, ShieldCheck, CalendarBlank, AddressBook } from '@phosphor-icons/react';

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  // Bottom nav: Home | Events | Ladder | Directory | (Settings for members,
  // Admin for admins). Admins reach Settings via the Admin panel or /settings;
  // this keeps the nav readable at 5 items across roles.
  const navItems = [
    { path: '/', icon: House, label: 'Home' },
    { path: '/events', icon: CalendarBlank, label: 'Events' },
    { path: '/ladder', icon: ListNumbers, label: 'Ladder' },
    { path: '/directory', icon: AddressBook, label: 'Directory' },
    user?.role === 'admin'
      ? { path: '/admin', icon: ShieldCheck, label: 'Admin' }
      : { path: '/settings', icon: GearSix, label: 'Settings' },
  ];

  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-0 right-0 z-50 bg-[#fbfaf8] border-t border-[#e3dcd1] pb-safe pt-2 pb-3 px-6 flex justify-around items-center max-w-md mx-auto sm:max-w-xl md:max-w-2xl lg:max-w-4xl"
    >
      {navItems.map((item) => {
        // Home: exact match only. Events: also match /events/:slug. Others: exact.
        const isActive =
          location.pathname === item.path ||
          (item.path === '/events' && location.pathname.startsWith('/events'));
        return (
          <button
            key={item.path}
            data-testid={`nav-${item.label.toLowerCase()}`}
            onClick={() => navigate(item.path)}
            className={`flex flex-col items-center gap-0.5 px-3 py-1 rounded-xl transition-all ${
              isActive
                ? 'text-[#015e3f]'
                : 'text-[#6a766e] hover:text-[#013523]'
            }`}
          >
            <item.icon size={22} weight={isActive ? 'fill' : 'regular'} />
            <span className="text-[10px] font-medium">{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
